import React, { Fragment } from 'react';
import { IconButton } from '@mui/material';
import { GridRenderCellParams } from '@mui/x-data-grid';
import InfoIcon from '@mui/icons-material/Info';

export const renderDetailedInfo = (params: GridRenderCellParams<any, any, any>) => {
  return (
    <Fragment>
      <IconButton size="small">
        <InfoIcon fontSize="medium" color="primary"/>
      </IconButton>
    </Fragment>
  );
};
